import React from 'react';

import { useAuthInitialization } from '@hooks/useAuth';

import { isCurrentPathPublic } from '../../utils/publicRoutes';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  // Public share pages have no session to bootstrap; probing /me would only produce a
  // 401 and bounce the visitor to the login screen.
  useAuthInitialization({ enabled: !isCurrentPathPublic() });

  return <>{children}</>;
};

AuthProvider.displayName = 'AuthProvider';
